import {
  DASHBOARD_PATH,
  CONFIGURATION_PATH,
  HEALTH_PLANS_PATH,
  HOUSING_DATABASE_PATH,
  HOUSING_EXPENSE_REQUEST_PATH,
  HOUSING_EXPENSE_CREATE_REQUEST_PATH,
  Members_PATH,
  USERS_PATH,
  SURVEY_HISTORY_PATH,
} from "constants/routePaths";
import { forEach, startCase } from "lodash";
import moment from "moment";
import React from "react";
import { useLocation } from "react-router-dom/dist";

export const getBreadcrumbs = (pathname) => {
  const urlPath = pathname.split("/");
  const [, ...usablePath] = urlPath;

  let breadCrumbs = [
    {
      name: "Dashboard",
      route: DASHBOARD_PATH,
    },
  ];
  let fullTrailPath = "/";

  forEach(usablePath, (path, i) => {
    fullTrailPath =
      fullTrailPath + `${path + (i !== usablePath.length - 1 ? "/" : "")}`;
    if (fullTrailPath !== "/dashboard")
      breadCrumbs.push({
        name: startCase(path),
        route: fullTrailPath,
      });
  });

  // In case of edit path remove the id before edit
  if (pathname.includes("edit")) {
    breadCrumbs.splice(breadCrumbs.length - 2, 1);
  }

  return breadCrumbs;
};
export const getAccessToken = () => {
  return localStorage.getItem("access_token");
};
export const getRefreshToken = () => {
  return localStorage.getItem("refresh_token");
};
export const getCreatedAt = () => {
  return localStorage.getItem("created_at");
};
export const getExpiresIn = () => {
  return localStorage.getItem("expires_in");
};
export const getUserInfo = () => {
  return JSON.parse(localStorage.getItem("uuInfo"));
};
export const setAccessToken = (accessToken) => {
  return localStorage.setItem("access_token", accessToken);
};
export const setRefreshToken = (refreshToken) => {
  return localStorage.setItem("refresh_token", refreshToken);
};
export const setUserInfoInStorage = (userInfo = {}) => {
  return localStorage.setItem("uuInfo", JSON.stringify(userInfo));
};
export const setTokenCreatedAt = (createdAt) => {
  return localStorage.setItem("created_at", createdAt);
};
export const setTokenExpiresIn = (expiresIn) => {
  return localStorage.setItem("expires_in", expiresIn);
};
export function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export const checkUserLoggedInStatus = (loginData) => {
  if (loginData?.status_code === 200 || getAccessToken()) {
    return true;
  }

  return false;
};
export const removeAccessToken = () => {
  localStorage.removeItem("access_token");
};
export const removeRefreshToken = () => {
  localStorage.removeItem("refresh_token");
};
export const removeCreatedAt = () => {
  localStorage.removeItem("created_at");
};
export const removeExpiresIn = () => {
  localStorage.removeItem("expires_in");
};
export const removeUserInfoFromStorage = () => {
  localStorage.removeItem("uuInfo");
};
export const isSidebarVisible = (route) => {
  const encounterPattern = /\/community-outreach\/[^/]+-encounter\/\d+$/;

  return !(route.includes("/survey/") || encounterPattern.test(route));
};
export const showSurvey = (route) => {
  // return !(route.includes('/survey/') || route.includes('/survey-history/'));
  return !route.includes("/survey/");
};
export function diffHours(dt2, dt1) {
  // Calculate the difference in milliseconds between the two provided Date objects by subtracting the milliseconds value of dt1 from the milliseconds value of dt2
  var diff = (dt2.getTime() - dt1.getTime()) / 1000;
  // Convert the difference from milliseconds to hours by dividing it by the number of seconds in an hour (3600)
  diff /= 60 * 60;
  // Return the absolute value of the rounded difference in hours
  return Math.abs(Math.round(diff));
}
export function highlightFirstMatch(string, subString) {
  if (!string) return "";
  if (!subString) return string;
  const startIndex = string?.toLowerCase().indexOf(subString.toLowerCase());

  if (startIndex === -1) {
    return string;
  }

  const matched = string.substr(startIndex, subString.length);
  const highlightedString = (
    <>
      {string.substring(0, startIndex)}
      <span className="highlight">{matched}</span>
      {string.substring(startIndex + subString.length)}
    </>
  );

  return highlightedString;
}
export function capitalizeName(name) {
  if (!name) {
    return ""; // Handle undefined, null, or empty string input
  }

  const words = name.trim().split(" ");
  const capitalizedWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
  );
  const capitalizedFullName = capitalizedWords.join(" ");

  return capitalizedFullName;
}
export const disableFutureDates = (current) => {
  const today = new Date();
  return current && current.isSameOrBefore(today, "day");
};
export const formatLocation = (text) => {
  const [city = "", country = ""] = text.split("-");

  const formattedCity = city
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

  const formattedCountry = country?.toUpperCase?.() || "";

  return `${formattedCity}${country ? "-" + formattedCountry : ""}`;
};

export const disablePastDates = (current) => {
  const today = new Date();
  return current && !current.isBefore(today, "day");
};
export const formatString = (str) => {
  if (!str || str === "") return "";

  const input = String(str).trim();
  const cleanInput = input.replace(/_/g, " ");
  const words = cleanInput.split(" ").filter((word) => word);
  return words
    .map((word) => {
      if (word.toLowerCase() === "or") {
        return "or";
      }
      const cleanWord = word.replace(/[()]/g, "");
      if (cleanWord.length <= 3) {
        return word.replace(cleanWord, cleanWord.toUpperCase());
      }

      return word.replace(
        cleanWord,
        cleanWord.charAt(0).toUpperCase() + cleanWord.slice(1).toLowerCase(),
      );
    })
    .join(" ");
};
export const converyQueryObjectToFilterString = (obj) => {
  if (!obj) return "";
  return Object.keys(obj)
    .filter((key) => !!obj[key])
    .map((key) => `${key}=${obj[key]}`)
    .join("&");
};

export const formatDate = (data) => {
  const formated = moment(data, "YYYY/MM/DD").format("MM/DD/YYYY");
  return formated;
};

export const DateFormat = (date) => {
  if (!date) return "";

  const d = new Date(date);
  if (isNaN(d.getTime())) return "";

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}/${month}/${year}`;
};

// Role-based access control functions
export const getUserRole = () => {
  const userInfo = getUserInfo();
  return userInfo?.type || null;
};

export const isAdminUser = () => {
  const userInfo = getUserInfo();
  return Boolean(userInfo?.admin);
};
// Define role-based access rules
export const roleAccessRules = {
  ProgramCoordinator: [
    Members_PATH,
    SURVEY_HISTORY_PATH,
    HOUSING_EXPENSE_REQUEST_PATH,
    HOUSING_EXPENSE_CREATE_REQUEST_PATH,
    HOUSING_DATABASE_PATH,
  ],
  HousingNavigator: [
    Members_PATH,
    SURVEY_HISTORY_PATH,
    HOUSING_EXPENSE_REQUEST_PATH,
    HOUSING_EXPENSE_CREATE_REQUEST_PATH,
    HOUSING_DATABASE_PATH,
  ],
  CsManager: [
    Members_PATH,
    SURVEY_HISTORY_PATH,
    HOUSING_EXPENSE_REQUEST_PATH,
    HOUSING_EXPENSE_CREATE_REQUEST_PATH,
    HOUSING_DATABASE_PATH,
    HEALTH_PLANS_PATH,
    USERS_PATH,
    CONFIGURATION_PATH,
  ],
  Executive: [
    Members_PATH,
    SURVEY_HISTORY_PATH,
    HOUSING_EXPENSE_REQUEST_PATH,
    HOUSING_DATABASE_PATH,
    HEALTH_PLANS_PATH,
    USERS_PATH,
    CONFIGURATION_PATH,
  ],
  Accounting: [
    Members_PATH,
    SURVEY_HISTORY_PATH,
    HOUSING_EXPENSE_REQUEST_PATH,
    HOUSING_DATABASE_PATH,
    HEALTH_PLANS_PATH,
    USERS_PATH,
    CONFIGURATION_PATH,
  ],
  // Add other roles as needed
  Admin: [HOUSING_DATABASE_PATH, HEALTH_PLANS_PATH, CONFIGURATION_PATH],
  // Default: allow all routes for other roles
  default: [
    DASHBOARD_PATH,
    Members_PATH,
    SURVEY_HISTORY_PATH,
    HOUSING_EXPENSE_REQUEST_PATH,
    HOUSING_EXPENSE_CREATE_REQUEST_PATH,
    HOUSING_DATABASE_PATH,
    HEALTH_PLANS_PATH,
    USERS_PATH,
    CONFIGURATION_PATH,
  ],
};
export const hasAccessToRoute = (route, userRole) => {
  if (!userRole) return false;

  // Base allowed routes from role
  let allowedRoutes = roleAccessRules[userRole] || roleAccessRules["default"];

  // If user has admin flag, merge Admin routes in addition to their role
  if (isAdminUser()) {
    const adminRoutes = roleAccessRules["Admin"] || [];
    allowedRoutes = Array.from(
      new Set([...(allowedRoutes || []), ...adminRoutes]),
    );
  }

  // Check exact match first
  if (allowedRoutes.includes(route)) {
    return true;
  }

  // Check if route matches any allowed route pattern (for dynamic routes like /members/34)
  for (const allowedRoute of allowedRoutes) {
    // Convert route path to regex pattern
    const pattern = allowedRoute.replace(/:[^/]+/g, "[^/]+");
    const regex = new RegExp(`^${pattern}$`);

    if (regex.test(route)) {
      return true;
    }
  }

  return false;
};

export const getFilteredRoutes = (routes, userRole) => {
  if (!userRole) return [];

  return routes.filter((route) => hasAccessToRoute(route.path, userRole));
};

// Role-based permission functions
export const canApproveRejectExpenseRequests = (userRole) => {
  // Program Coordinators, CS Managers, Executives, and Accounting can approve/reject
  return (
    userRole === "ProgramCoordinator" ||
    userRole === "CsManager" ||
    userRole === "Executive" ||
    userRole === "Accounting"
  );
};

export const canCreateExpenseRequests = (userRole) => {
  // Program Coordinators, Housing Navigators, and CS Managers can create
  return (
    userRole === "ProgramCoordinator" ||
    userRole === "HousingNavigator" ||
    userRole === "CsManager"
  );
};

export const canConfirmPaymentIssuance = (userRole) => {
  // Only Accounting personnel can confirm payment issuance
  return userRole === "Accounting";
};

export const canManageUsers = (userRole) => {
  // CS Managers, Executives, and Accounting can manage users
  return (
    userRole === "CsManager" ||
    userRole === "Executive" ||
    userRole === "Accounting"
  );
};

export const canAccessConfiguration = (userRole) => {
  // CS Managers, Executives, Accounting, and Admins (or admin flag) can access configuration
  return (
    userRole === "CsManager" ||
    userRole === "Executive" ||
    userRole === "Accounting" ||
    userRole === "Admin" ||
    isAdminUser()
  );
};

export const canAccessHealthPlans = (userRole) => {
  // CS Managers, Executives, Accounting, and Admins (or admin flag) can access health plans
  return (
    userRole === "CsManager" ||
    userRole === "Executive" ||
    userRole === "Accounting" ||
    userRole === "Admin" ||
    isAdminUser()
  );
};

export const canViewOnlyHealthPlans = (userRole) => {
  // If user has admin flag, they have full access (not view-only)
  if (isAdminUser()) {
    return false;
  }
  // CS Managers, Executives, and Accounting can only view health plans (not edit)
  return (
    userRole === "CsManager" ||
    userRole === "Executive" ||
    userRole === "Accounting"
  );
};

export const canViewOnlyConfiguration = (userRole) => {
  // If user has admin flag, they have full access (not view-only)
  if (isAdminUser()) {
    return false;
  }
  // CS Managers, Executives, and Accounting can only view configuration (not edit)
  return (
    userRole === "CsManager" ||
    userRole === "Executive" ||
    userRole === "Accounting"
  );
};

export const canDeletePropertyDatabase = (userRole) => {
  // Only Admins (role) or users with admin flag can delete from property database
  return userRole === "Admin" || isAdminUser();
};

export const sortData = (data) => {
  if (!Array.isArray(data)) {
    return [];
  }
  return [...data].sort((a, b) => a.name.localeCompare(b.name));
};
